import {createFetchActions} from '../../services/createActions'
import * as axios from 'axios'
import {abcmResult2PivotTableQuery} from './abcmResult2Queries'
import {getConfigBaseUrl, getPMSGraphBaseUrl} from '../../services/apiService'
import {getAuthToken} from '../../services/authService'
import {get, post, put} from '../../services/createAPICall'

export const GET_ABCMRESULT_2_PIVOT_TABLE = createFetchActions('GET_ABCMRESULT_2_PIVOT_TABLE')
export const SET_PIVOT_TABLE_CONFIG = 'SET_PIVOT_TABLE_CONFIG'
export const SET_ABCM2_DISPLAY_VIEW = 'SET_ABCM2_DISPLAY_VIEW'
export const GET_ABCMRESULT2_LAST_SET_FILTERS = createFetchActions('GET_ABCMRESULT2_LAST_SET_FILTERS')
export const CREATE_ABCMRESULT2_LAYOUT = createFetchActions('CREATE_ABCMRESULT2_LAYOUT')
export const UPDATE_ABCMRESULT2_LAST_SET_FILTERS = createFetchActions('UPDATE_ABCMRESULT2_LAST_SET_FILTERS')

export function getAbcmResultPivotTable(portfolioId, rankingId, securityId, pageNumber) {
	const query = abcmResult2PivotTableQuery(portfolioId, rankingId, securityId, pageNumber)
	return function (dispatch) {
		dispatch({type: GET_ABCMRESULT_2_PIVOT_TABLE.triggered})
		const instance = axios.default.create({
			baseURL: `${getPMSGraphBaseUrl()}`,
			timeout: 1000000,
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${getAuthToken()}`,
			},
		})

		instance
			.post(
				'',
				JSON.stringify({
					query: query,
				})
			)
			.then(data => {
				dispatch({
					type: GET_ABCMRESULT_2_PIVOT_TABLE.succeeded,
					response: data.data,
				})
			})
	}
}

export const setPivotTableConfig = (data, id, metric) => {
	return {
		type: SET_PIVOT_TABLE_CONFIG,
		response: {
			metric,
			data: {
				id,
				pivotTableConfig: data,
			},
		},
	}
}

export const setAbcmDisplayView = data => {
	return {
		type: SET_ABCM2_DISPLAY_VIEW,
		response: {
			data,
		},
	}
}

export const createLastSavedFilters = widget => (dispatch: any) => {
	return dispatch(post(CREATE_ABCMRESULT2_LAYOUT, `${getConfigBaseUrl()}/v2/config/users/layouts/`, widget, null))
}

export const getLastSavedFilters = screenId => (dispatch: any) => {
	return dispatch(get(GET_ABCMRESULT2_LAST_SET_FILTERS, `${getConfigBaseUrl()}/v2/config/users/layouts/${screenId}`))
}

export const updateLastSavedFilters = widget => (dispatch: any) => {
	return dispatch(
		put(UPDATE_ABCMRESULT2_LAST_SET_FILTERS, `${getConfigBaseUrl()}/v2/config/users/layouts/`, widget, null)
	)
}
